import React from "react";

import TabPage from "../pages/TabPage";

export default function App() {
    return (
        <div>
            <TabPage />
        </div>
    )
}

